<template>
  <b-row>
    <b-col lg="12">
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading
            :module-id="access.module_id"
            :profile-id="access.profile_id"
            :reference="access.view_reference"
            summary-only
          />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions">
              <TabHeaderActions />
            </div>
          </div>
        </section>
      </b-card>

      <b-row>
        <b-col lg="4">
          <!-- DATOS BASICOS CLIENTE -->
          <b-card>
            <b-row>
              <b-col class="d-flex align-items-center">
                <b-avatar :src="customers.image"
                          size="25px"
                          v-if="customers.image">
                </b-avatar>
                <b-avatar v-else
                          size="25px"
                          :text="avatarFromName(customers.name).text"
                          :style="avatarFromName(customers.name).style">
                </b-avatar>
                <b class="ml-2">{{customers.name}}</b>
                <b-badge variant="danger" class="ml-2" v-if="customers.id && !customers.active">Inactivo</b-badge>
                <b-button variant="link" class="list-view-icon-btn ml-auto" v-b-tooltip.hover title="Editar cliente" aria-label="Editar cliente" @click="edit()">
                  <AppIcon name="edit" />
                </b-button>
              </b-col>
            </b-row>

            <b-row>
              <b-col>

                <div class="ml-5 mt-2">
                  <div v-if="!customers.email">
                    <AppIcon name="mail" /> &nbsp;&nbsp;
                    <b-badge variant="warning" class="badget-custom">No tiene un email asociado</b-badge>
                  </div>
                  <div v-else>
                    <AppIcon name="mail" /> &nbsp;&nbsp;
                    <b-link :href="'mailto:' + customers.email">
                      {{ customers.email }}
                    </b-link>
                  </div>
                </div>

                <div class="ml-5" v-if="customers.phone">
                  <AppIcon name="call" /> &nbsp;&nbsp;
                  <b-link :href="'tel:' + customers.phone">
                    {{ customers.phone }}
                  </b-link>
                </div>

              </b-col>
            </b-row>
            
            <div class="app-modal-detail-list view-customer-info-blocks"
                 v-if="customers.registration_website || hasValue(customers.observations) || hasValue(customers.observations_delivery) || hasValue(customers.observations_delivery_address)">

              <b-badge v-if="customers.registration_website" variant="warning" class="mb-2">Registro desde Sitio Web</b-badge>

              <div class="app-modal-detail-list__row" v-if="hasValue(customers.observations)">
                <span class="app-modal-detail-list__label"><AppIcon name="chat-square-text" class="mr-1" />Observaciones</span>
                <span class="app-modal-detail-list__value">{{ customers.observations }}</span>
              </div>

              <div class="app-modal-detail-list__row" v-if="hasValue(customers.observations_delivery)">
                <span class="app-modal-detail-list__label"><AppIcon name="truck" class="mr-1" />Transporte</span>
                <span class="app-modal-detail-list__value">{{ customers.observations_delivery }}</span>
              </div>

              <div class="app-modal-detail-list__row" v-if="hasValue(customers.observations_delivery_address)">
                <span class="app-modal-detail-list__label"><AppIcon name="location_on" class="mr-1" />Dirección de Entrega</span>
                <span class="app-modal-detail-list__value">{{ customers.observations_delivery_address }}</span>
              </div>
            </div>
          </b-card>

          <!-- DATOS EXTRAS -->
          <b-card v-if="getFieldInfo">
            <div class="list-view-drawer__section-title">
              <AppIcon name="info" /> Información Adicional
            </div>
            <div class="app-modal-detail-list">
              <div class="app-modal-detail-list__row">
                <span class="app-modal-detail-list__label">DNI</span>
                <span class="app-modal-detail-list__value">{{this.getFieldInfo['dni']}}</span>
              </div>
              <div class="app-modal-detail-list__row">
                <span class="app-modal-detail-list__label">Instagram</span>
                <span class="app-modal-detail-list__value">{{this.getFieldInfo['instagram']}}</span>
              </div>
              <div class="app-modal-detail-list__row">
                <span class="app-modal-detail-list__label">Newsletter</span>
                <span class="app-modal-detail-list__value">{{this.getFieldInfo['newsletter'] ? 'SI' : 'NO'}}</span>
              </div>
            </div>
          </b-card>

          <Contacts :customers="customers" :customersID="customersID"></Contacts>
        </b-col> 

        <b-col lg="8">          
          <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-dark"                               
                  v-if="showTab">

            <b-tab v-if="this.configTabs.fiscal.show" :active="tabs.fiscal" @click="setActiveTab('fiscal')">
                <template #title><AppIcon name="description" class="mr-1" /> Datos Fiscales</template>
                <tab-fiscal v-if="isCustomersSales" :customers="customers" :customersID="customersID"></tab-fiscal>
            </b-tab>

            <b-tab v-if="this.configTabs.reports.show" :active="tabs.reports" @click="setActiveTab('reports')" lazy>
              <template #title><AppIcon name="bar-chart" class="mr-1" /> Informes</template>
              <tab-report :customers="customers" :customersID="customersID" :reports="configTabs.reports"></tab-report>
            </b-tab>

            <b-tab v-if="this.configTabs.list.show" :active="tabs.price_list" @click="setActiveTab('price_list')">
                <template #title><AppIcon name="tags" class="mr-1" /> Lista de Precio</template>
                <tab-list v-if="isCustomersPriceList" :customers="customers" :customersID="customersID"></tab-list>
            </b-tab>

            <b-tab v-if="this.configTabs.products.show" :active="tabs.products" @click="setActiveTab('products')" lazy>
              <template #title><AppIcon name="box" class="mr-1" /> Productos</template>
              <tab-products :customers="customers" :customersID="customersID"></tab-products>
            </b-tab>

            <b-tab v-if="this.configTabs.courses.show" :active="tabs.courses" @click="setActiveTab('courses')" lazy>
              <template #title><AppIcon name="book" class="mr-1" /> Cursos</template>
              <tab-courses :customers="customers" :customersID="customersID"></tab-courses>
            </b-tab>

            <b-tab v-if="this.configTabs.services.show" :active="tabs.services" @click="setActiveTab('services')" lazy>
                <template #title><AppIcon name="tools" class="mr-1" /> Servicios</template>
                <tab-services :customers="customers"
                              :customersID="customersID"
                              :refreshing="servicesRefreshing"
                              @refresh="refreshServices"></tab-services>
            </b-tab>

            <b-tab v-if="this.configTabs.currentAccount.show" :active="tabs.currentAccount" @click="setActiveTab('currentAccount')" lazy>
              <template #title><AppIcon name="money" class="mr-1" /> Cuenta Corriente</template>
              <tab-currentAccount :customers="customers" :customersID="customersID"></tab-currentAccount>
            </b-tab>

            <b-tab v-if="this.configTabs.accountingAccount.show" :active="tabs.accountingAccount" @click="setActiveTab('accountingAccount')" lazy>
              <template #title><AppIcon name="calculator" class="mr-1" /> Cuenta Contable</template>
              <tab-accountingAccount :customers="customers" :customersID="customersID"></tab-accountingAccount>
            </b-tab>

            <b-tab v-if="this.configTabs.reasons.show" :active="tabs.reasons" @click="setActiveTab('reasons')" lazy>
                <template #title><AppIcon name="flag" class="mr-1" /> Motivos</template>
                <tab-reason :customers="customers" :customersID="customersID"></tab-reason>
            </b-tab>

            <b-tab v-if="this.configTabs.zones.show" :active="tabs.zones" @click="setActiveTab('zones')" lazy>
                <template #title><AppIcon name="location_on" class="mr-1" /> Zona</template>
                <tab-zones :customers="customers" :customersID="customersID"></tab-zones>
            </b-tab>

            <b-tab :active="tabs.notes" @click="setActiveTab('notes')" lazy>
              <template #title><AppIcon name="sticky_note_2" class="mr-1" /> Notas</template>
              <RichEditorImages v-model="customers.notes" label="Notas importantes" :with-gallery="false" :disabled="!notesEditing" />
              <div class="text-right mt-3">
                <b-button v-if="!notesEditing" variant="outline-secondary" size="sm" @click="notesEditing = true">
                  <AppIcon name="edit" class="mr-1" />Editar notas
                </b-button>
                <b-button v-else variant="dark" size="sm" :disabled="notesSaving" @click="saveNotes(customers.notes)">
                  <b-spinner v-if="notesSaving" small class="mr-1" />
                  <AppIcon v-else name="save" class="mr-1" />Guardar notas
                </b-button>
              </div>
            </b-tab>
          </b-tabs>
          <EmptyState v-else
                      icon="person"
                      title="No se encontró información de módulos relacionados" />
        </b-col>

      </b-row>

      <b-card class="mt-2" body-class="py-2">
        <div class="list-view-footer">
          <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
            <AppIcon name="back" />
            Volver
          </b-button>
        </div>
      </b-card>

      <b-modal v-model="modal.form.active" :key="modal.form._id" :id="modal.form._id">
        <div slot="modal-header" class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="edit" /></span>
          <h5 class="app-modal-header__title">{{this.modal.form.title}}</h5>
        </div>
        <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-dark">
          <b-tab>
            <template #title><AppIcon name="person" class="mr-1" /> General</template>
            <b-row>
              <b-col md="5">
                <b-form-group label="Logo">
                  <Imagen :images="crud.form.image" @load-image="crud.form.image = $event" typeImage="Logo"/>
                </b-form-group>
              </b-col>
              <b-col md="7">
                <b-row>
                  <b-col md="12">
                    <b-form-checkbox v-model="crud.form.active" switch size="sm" class="mt-4 pull-right">Activo</b-form-checkbox>
                  </b-col>
                  <b-col md="12">
                    <b-form-group label="Código">
                      <b-form-input type="text" size="sm" v-model="crud.form.code" required placeholder="Ingresar un código"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group label="Nombre">
                      <b-form-input type="text" size="sm" v-model="crud.form.name" required placeholder="Ingresar un nombre"></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
              <b-col md="12">
                <b-form-group label="Email">
                  <b-form-input type="text" size="sm" v-model="crud.form.email" required placeholder="Ingresar un email"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group label="Teléfono" description="Ej: 5493416908870 (13 dígitos)">
                  <b-form-input type="text" size="sm" v-model="crud.form.phone" required placeholder="Ingresar un teléfono"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab>
            <template #title><AppIcon name="chat-square-text" class="mr-1" /> Observaciones</template>
            <b-row>
              <b-col md="12">
                <b-form-group label="Observaciones">
                  <app-textarea v-model="crud.form.observations" placeholder="Ingresar una observación..." rows="3" size="sm"></app-textarea>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group label="Transporte">
                  <app-textarea v-model="crud.form.observations_delivery" placeholder="Ingresar el transporte que utiliza por defecto..." rows="3" size="sm"></app-textarea>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group label="Dirección de Entrega">
                  <app-textarea v-model="crud.form.observations_delivery_address" placeholder="Ingresar la dirección de entrega por defecto..." rows="3" size="sm"></app-textarea>
                </b-form-group>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.form.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="save()"><AppIcon name="save" class="mr-1" />Guardar</b-button>
        </div>
      </b-modal>

    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'
  import Theme from '@/config/theme'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import Widget from '@/components/inc/widget/widget'
  import {EventBus} from '@/handler/event-bus'
  import Param from '@/config/parameters'  
  import Storage from '@/handler/storageLocal'  
  import TabReport from './tabs/reports'
  import TabFiscal from './tabs/fiscal'
  import TabList from './tabs/list'
  import TabCourses from './tabs/courses'
  import TabServices from './tabs/services'
  import TabCurrentAccount from './tabs/currentAccount'
  import TabAccountingAccount from './tabs/accountingAccount'
  import TabProducts from './tabs/products'
  import TabReason from './tabs/reason'
  import TabZones from './tabs/zones'
  import Contacts from './contacts/crud'
  import Funciones from '@/handler/funciones'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'
  import Imagen from '@/components/inc/image/image'
  import RichEditorImages from '@/components/inc/editor/RichEditorImages'

  export default {
    components: {
      Widget,
      TabReport,
      TabFiscal,
      TabList,
      TabCourses,
      TabServices,
      TabCurrentAccount,
      TabAccountingAccount,
      TabProducts,
      TabReason,
      TabZones,
      Contacts,
      TabHeaderActions,
      Imagen,
      RichEditorImages,
    },
    data: () => {
      return {
        access: {
          module_id: Modules.CLIENTES,
          profile_id: Profiles.PERSONAL,
          view_reference: 'view',
          elements: {}
        },
        parameters: {
          haveColors: Helper.hasParametersAccess(Param.P8),
          haveWaist: Helper.hasParametersAccess(Param.P9),
          haveColorsWaist: Helper.hasParametersAccess(Param.P17),
          haveReason: Helper.hasParametersAccess(Param.P54),
          enableDiscOrAdd: Helper.hasParametersAccess(Param.P53),
        },         
        configTabs: {
          reports: {
            show: false,
            access: {
              visits: false,
              payments: false,
              news: false,
              services: false,
              audit: false,
              marketing: false,
            },            
          },
          fiscal: {
            show: false,
          },
          list: {
            show: false,
          },
          courses: {
            show: false,
          },
          services: {
            show: false,
          },
          currentAccount: {
            show: false,
          },
          accountingAccount: {
            show: false,
          },
          products: {
            show: false,
          },     
          reasons: {
            show: false,
          },
          zones: {
            show: false,
          }
        },
        primaryColor: '',
        notesSaving: false,
        notesEditing: false,
        servicesRefreshing: false,
        customersID: 0,
        customers: {},
        modulesActive: [],
        crud: {
          form: {
            id: 0,
            name: '',
            phone: '',
            email: '',
            image: [],
            code: '',
            active: true,
            observations: '',
            observations_delivery: '',
            observations_delivery_address: '',
          }
        },
        modal: {
          form: {
            active: false,
            title: '',
            _id: '',
          }
        },
        tabs: {
          notes: false,
          fiscal: true,
          price_list: false,
          reports: false,
          courses: false,
          currentAccount: false,
          accountingAccount: false,
          products: false,
          reasons: false,
          zones: false,
        }
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },
    mounted() {
      this.customersID = this.$route.params.customersID  
      this.modulesActive = Session.getSession().auth.user.permissions.modules

      this.setup()
      this.load()
      this.configAccess()
      this.validation()

      this.restoreStatusTabsStorage()
    }, 
    computed: {
      showTab () {
        var status = true
        if(this.configTabs.reports.show ||
           this.configTabs.fiscal.show ||
           this.configTabs.list.show ||
           this.configTabs.courses.show ||
           this.configTabs.services.show ||
           this.configTabs.currentAccount.show ||
           this.configTabs.accountingAccount.show ||
           this.configTabs.products.show ||
           this.configTabs.reasons.show) {
          status = true
        }
        return status
      },    
      isCustomersSales() {  
        if(this.customers.data_fiscal) {
          return true
        } else {
          if(this.customers.data_fiscal==undefined) {
            return true
          } else {
            return false
          }
        }
      },
      isCustomersPriceList() {        
        if(this.customers.price_list) {
          return true
        } else {
          if(this.customers.sale==undefined) {
            return true
          } else {
            return false
          }
        }
      }, 
      getFieldInfo() {        
        if(this.customers.field_info) {
          var field_info = JSON.parse(this.customers.field_info)
          return field_info           
        } else {
          return null
        }
      },   
      isSeller() {
        var seller = Helper.getSeller()
        if(seller) {
          return true
        } else {
          return false
        }
      },  

      hasOnlyProduct() {      
        return !this.parameters.haveColorsWaist && !this.parameters.haveColors && !this.parameters.haveWaist
      },    
      hasReason() {
        return this.parameters.haveReason
      }
    },
    methods: {
      avatarFromName(name) {
        return Funciones.avatarFromName(name)
      },
      hasValue(value) {
        return !!value && value !== 'null'
      },
      saveNotes(notes) {
        this.notesSaving = true
        serviceAPI.guardarNotas(this.customersID, notes)
          .then(response => {
            this.customers.notes = response.data.notes
            this.notesEditing = false
            this.$awn.success('Notas guardadas con éxito')
          })
          .catch(error => this.$awn.alert(Error.showError(error)))
          .finally(() => { this.notesSaving = false })
      },
      refreshServices() {
        if(this.servicesRefreshing) return

        this.servicesRefreshing = true
        serviceAPI.mostrar(this.customersID)
          .then(response => {
            this.customers = response.data
            this.$awn.success('Servicios actualizados')
          })
          .catch(error => this.$awn.alert(Error.showError(error)))
          .finally(() => { this.servicesRefreshing = false })
      },
      setMetaTitle(title) {
        EventBus.$emit('Update:TabTitle', 'Cliente: ' + title)        
      },
      validation() {        
        var seller = Helper.getSeller()   

        if(seller) {                    
          var result = serviceAPI.mostrarVendedorWithCustomers(seller.id)

          result.then((response) => {        
            var objSeller = response.data 
            
            if(objSeller.customers) {
              var status = false
              objSeller.customers.forEach(element => {              
                if(this.customersID == element.id) {
                  status = true
                }   
              });
              if(!status) {
                this.$router.push({ name: 'Error403' })    
              }
            }                      
          })          
        }
      },            
      load() {
        let loader = this.$loading.show();
        var result = serviceAPI.mostrar(this.customersID)

        result.then((response) => {
          var data = response.data
          this.customers = data         
          this.notesEditing = false

          this.setMetaTitle(this.customers.name)
        
          loader.hide()
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error))
        });
      },      
      setup () {
        if(Session.getSession().settings) {
          this.primaryColor = Theme.PRIMARY_COLOR

          this.createCSS()
        }
      },
      edit() {
        this.crud.form.id = this.customers.id
        this.crud.form.name = this.customers.name
        this.crud.form.phone = (this.customers.phone!=null) ? this.customers.phone : ''
        this.crud.form.email = (this.customers.email!=null) ? this.customers.email : ''
        this.crud.form.code = (this.customers.code!=null) ? this.customers.code : ''
        this.crud.form.active = this.customers.active
        this.crud.form.observations = this.hasValue(this.customers.observations) ? this.customers.observations : ''
        this.crud.form.observations_delivery = this.hasValue(this.customers.observations_delivery) ? this.customers.observations_delivery : ''
        this.crud.form.observations_delivery_address = this.hasValue(this.customers.observations_delivery_address) ? this.customers.observations_delivery_address : ''

        if(this.customers.image && this.customers.image.length>0) {
          this.crud.form.image = [{ path: this.customers.image }]
        } else {
          this.crud.form.image = []
        }

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Editar Cliente --> (" + this.crud.form.id + ")" + this.crud.form.name
        this.modal.form.active = true
      },
      save() {
        if(this.crud.form.email) {
          var expreg = new RegExp("^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:[.][a-zA-Z0-9-]+)*$")
          if (!expreg.test(this.crud.form.email)) {
            this.$awn.alert("El email no posee un formato válido")
            return false
          }
        }
        if(this.crud.form.phone) {
          if(!Funciones.validarTelefonoWhatsapp(this.crud.form.phone)) {
            this.$awn.alert("El nro de télefono no posee un formato válido para Whatsapp")
            return false
          }
        }

        let loader = this.$loading.show();
        var image = new FormData();
        this.crud.form.image.forEach((value, key) => {
          image.append(key, value.path);
        })

        var result = serviceAPI.editar(JSON.stringify(this.crud.form), image);
        result.then(() => {
          this.modal.form.active = false
          loader.hide()
          this.load()
          this.$awn.success("Datos guardados con éxito");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },
      createCSS() {
        var hoja = document.createElement('style')
        hoja.innerHTML = ""      
        hoja.innerHTML = hoja.innerHTML  + ".list-group-item-action:hover, .list-group-item-action:focus { background-color: " + this.primaryColor + "; }"
        hoja.innerHTML = hoja.innerHTML  + ".view-customer-access-reports-widget-card-text-primary { color: " + this.primaryColor + "; }"
        
        document.body.appendChild(hoja);
      },
      configAccess() {
        this.modulesActive.forEach(element => {

          if(element.id == Modules.INFORME_VISITAS ||
             element.id == Modules.INFORME_COBRANZAS ||
             element.id == Modules.INFORME_NOVEDADES ||
             element.id == Modules.INFORME_SERVICIOS ||
             element.id == Modules.INFORME_AUDITORIA ||
             element.id == Modules.INFORME_MARKETING) {
               this.configTabs.reports.show = true

               if(element.id == Modules.INFORME_VISITAS) {
                 this.configTabs.reports.access.visits = true
               }
               if(element.id == Modules.INFORME_COBRANZAS) {
                 this.configTabs.reports.access.payments = true
               }
               if(element.id == Modules.INFORME_NOVEDADES) {
                 this.configTabs.reports.access.news = true
               }                              
               if(element.id == Modules.INFORME_SERVICIOS) {
                 this.configTabs.reports.access.services = true
               }                                
               if(element.id == Modules.INFORME_AUDITORIA) {
                 this.configTabs.reports.access.audit = true
               }                                 
               if(element.id == Modules.INFORME_MARKETING) {
                 this.configTabs.reports.access.marketing = true
               }                                       
          }

          if(element.id == Modules.VENTAS || element.id == Modules.PEDIDOS) {
            this.configTabs.fiscal.show = true
          }

          if(element.id == Modules.VENTAS) {
            this.configTabs.currentAccount.show = true
          }

          if(element.id == Modules.PRECIOS) {
            this.configTabs.list.show = true
          }

          if(element.id == Modules.CURSOS) {
            this.configTabs.courses.show = true
          }

          if(element.id == Modules.SERVICIOS) {
            this.configTabs.services.show = true
          }

          if(element.id == Modules.CONTABILIDAD) {
            this.configTabs.accountingAccount.show = true
          }

          if(element.id == Modules.PRODUCTOS && this.hasOnlyProduct && this.parameters.enableDiscOrAdd) {
            this.configTabs.products.show = true
          }

          if(element.id == Modules.PEDIDOS && this.hasReason) {
            this.configTabs.reasons.show = true
          }

          if(element.id == Modules.VENDEDORES) {
            this.configTabs.zones.show = true
          }
        })
      },

      //TABS
      disableAllTabs() {
        this.tabs.notes = false
        this.tabs.fiscal = false
        this.tabs.price_list = false
        this.tabs.reports = false
        this.tabs.courses = false
        this.tabs.services = false
        this.tabs.currentAccount = false
        this.tabs.accountingAccount = false
        this.tabs.products = false
        this.tabs.reasons = false
        this.tabs.zones = false
      },
      setActiveTab(value) {
        this.disableAllTabs()

        switch (value) {
          case 'notes':
            this.tabs.notes = true
            break;
          case 'fiscal':
            this.tabs.fiscal = true
            break;
        
          case 'reports':
            this.tabs.reports = true
            break;
            
          case 'price_list':
            this.tabs.price_list = true
            break;        

          case 'courses':
            this.tabs.courses = true
            break;        

          case 'services':
            this.tabs.services = true
            break;        

          case 'currentAccount':
            this.tabs.currentAccount = true
            break;        

          case 'accountingAccount':
            this.tabs.accountingAccount = true
            break;

          case 'products':
            this.tabs.products = true
            break;

          case 'reasons':
            this.tabs.reasons = true
            break;

          case 'zones':
            this.tabs.zones = true
            break;

          default:
            this.tabs.fiscal = true
            break;
        }

        this.saveStatusTabsStorage()
      },

      // FILTROS SAVE
      saveStatusTabsStorage() {
        Storage.setValue('tabs_view_cutomers', JSON.stringify(this.tabs))
      },
      restoreStatusTabsStorage() {
        if(Storage.getValue('tabs_view_cutomers')) {
          this.tabs = JSON.parse(Storage.getValue('tabs_view_cutomers'))
        }         
      },      
    }    
  }
</script>

<style>
  .view-customer-access-reports .list-group-item {
    padding: 6px;
  }
  .view-customer-access-reports h5 {
    margin-bottom: 0px;
  }
  .view-customer-access-reports svg {
    margin-bottom: 0px;
  }  
  .view-customer-access-reports-widget-card .card-header {
    padding: 5px;
  }
  .view-customer-access-reports-widget-card .card-body {
    padding: 5px;
  }  
  .view-customer-access-reports-widget-card-text-info {
    font-size: 12px;
  }
  .view-customer-access-reports-widget-card-text-primary {
    font-size: 25px;  
    font-weight: bold;
  }  
  .view-customer-access-reports-widget-card-empty {
    font-size: 15px;
    margin-top: 10px;
  }

  .view-customer-access-reports-widget-link-reports {
    cursor: pointer;
  }
  .view-customer-access-reports-widget-badget-custom {
    font-size: 100%;
  }  
  .view-customer-access-reports-widget-date {
    font-size: 13px;
  }
  .view-customer-access-reports-widget-info-extra {
    text-align: left;
    font-size: 15px;
  }
  .view-customer-access-reports-widget-scroll {
    height: 300px;
    overflow: overlay;
  }
</style>
<style scoped>
  hr {
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .view-customer-info-blocks {
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px solid var(--app-color-border);
  }
  .view-customer-info-blocks .app-modal-detail-list__value {
    white-space: pre-line;
    word-break: break-word;
  }
</style>
